import { createI18n } from 'vue-i18n'

function loadLocaleMessages () {
  const locales = require.context('./language_src', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true, // keeps $t / $i18n available in templates and options-API components
  locale: localStorage.getItem('language') || 'en',
  fallbackLocale: localStorage.getItem('language_fallback') || 'en',
  messages: loadLocaleMessages(),
  missingWarn: false,
  fallbackWarn: false
})

// vue-i18n 8 exposed `i18n.locale` directly; the rest of the app still reads/writes it that way.
Object.defineProperty(i18n, 'locale', {
  get () { return i18n.global.locale.value },
  set (v) { i18n.global.locale.value = v }
})

export default i18n
